import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProductShortUpdatePage = lazy(() => import('../views/update/ProductShortUpdatePage'));

export function ProductShortUpdatePageLazy() {
	return (
		<PageSuspense>
			<ProductShortUpdatePage />
		</PageSuspense>
	);
}
